// eslint-disable-next-line no-template-curly-in-string
export const maxLengthErrorMsg = "Length should be less than ${max}"
// eslint-disable-next-line no-template-curly-in-string
export const minLengthErrorMsg = "Length should be greater than ${min}"
// eslint-disable-next-line no-template-curly-in-string
export const lengthErrorMsg = "Length should be ${length}"
export const dropDownErrorMsg = "Please select a value"

export const ifscLengthErrorMsg = "Length should be 11"
